<script setup>
import { computed } from 'vue';
import { groupWorkingHours } from '../utils/time';
import { t } from '../i18n';

const props = defineProps({
	dealer: { type: Object, required: true },
});

const hoursGroups = computed(() => groupWorkingHours(props.dealer.hours));

const mapsUrl = computed(() => {
	const q = encodeURIComponent(props.dealer.address || `${props.dealer.lat},${props.dealer.lng}`);
	return `https://www.google.com/maps/search/?api=1&query=${q}`;
});

const directionsUrl = computed(() => {
	const q = encodeURIComponent(props.dealer.address || `${props.dealer.lat},${props.dealer.lng}`);
	return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
});
</script>

<template>
	<article class="dealer-details">
		<header class="dealer-details__header">
			<h2 class="dealer-details__name">{{ dealer.name }}</h2>

			<p v-if="dealer.ffl" class="dealer-details__ffl">{{ t.fflLicense(dealer.ffl) }}</p>
		</header>


		<ul class="dealer-details__meta">
			<li v-if="dealer.address" class="dealer-details__meta-row dealer-details__meta-row--address">
				{{ dealer.address }}
			</li>
			<li v-if="dealer.phone" class="dealer-details__meta-row dealer-details__meta-row--phone">
				{{ t.phone }} <a :href="`tel:${dealer.phone}`">{{ dealer.phone }}</a>
			</li>
			<li v-if="dealer.email" class="dealer-details__meta-row dealer-details__meta-row--email">
				{{ t.email }} <a :href="`mailto:${dealer.email}`">{{ dealer.email }}</a>
			</li>
			<li v-if="dealer.website" class="dealer-details__meta-row dealer-details__meta-row--website">
				{{ t.website }}
				<a :href="dealer.website" target="_blank" rel="noopener noreferrer">{{ dealer.website }}</a>
			</li>
		</ul>

		<div v-if="hoursGroups.length" class="dealer-details__hours">
			<p class="dealer-details__hours-title">{{ t.workingHours }}</p>
			<ul class="dealer-details__hours-list">
				<li v-for="group in hoursGroups" :key="group.label" class="dealer-details__hours-row">
					<span class="dealer-details__hours-day">{{ group.label }}:</span>
					<span class="dealer-details__hours-time">{{ group.text }}</span>
				</li>
			</ul>
		</div>

		<div class="dealer-details__actions">
			<a :href="mapsUrl" target="_blank" rel="noopener noreferrer" class="dealer-details__btn dl-btn dl-btn--primary">
				{{ t.openInGoogleMaps }}
			</a>
			<a :href="directionsUrl" target="_blank" rel="noopener noreferrer"
				class="dealer-details__btn dl-btn dl-btn--secondary">
				{{ t.getDirections }}
			</a>
		</div>
	</article>
</template>
